function formatNumberWithCommaSpace(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ", ");
}

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top < window.innerHeight &&
    rect.bottom > 0
  );
}

function animateCountersInElement(selector) {
  const block = document.querySelector(selector);
  const counters = block.querySelectorAll(".number");

  counters.forEach(counter => {
    const value = parseInt(counter.getAttribute("data-value"), 10);
    const duration = 4000;
    let startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const increment = Math.floor(value * (progress / duration));
      counter.textContent = formatNumberWithCommaSpace(Math.min(increment, value));

      if (progress < duration) {
        requestAnimationFrame(step);
      } else {
        counter.textContent = formatNumberWithCommaSpace(value);
      }
    }

    requestAnimationFrame(step);
  });
}

let aboutAnimated = false;
let socialAnimated = false;
let websiteAnimated = false;
let audienceAnimated = false;
let tvAnimated = false;
let whyUsAnimated = false;

window.addEventListener("scroll", function () {
  if (!aboutAnimated && isInViewport(document.querySelector(".about__list"))) {
    aboutAnimated = true;
    animateCountersInElement(".about__list");
  }

  if (!socialAnimated && isInViewport(document.querySelector(".social-reach__list"))) {
    socialAnimated = true;
    animateCountersInElement(".social-reach__list");
  }

  if (!websiteAnimated && isInViewport(document.querySelector(".website__list"))) {
    websiteAnimated = true;
    animateCountersInElement(".website__list");
  }

  if (!audienceAnimated && isInViewport(document.querySelector(".audience__list"))) {
    audienceAnimated = true;
    animateCountersInElement(".audience__list");
  }

  if (!tvAnimated && isInViewport(document.querySelector(".tv__list"))) {
    tvAnimated = true;
    animateCountersInElement(".tv__list");
  }

  if (!whyUsAnimated && isInViewport(document.querySelector(".why-us__list"))) {
    whyUsAnimated = true;
    animateCountersInElement(".why-us__list");
  }
});
